import { useSelector } from "react-redux";
import FormaCalculoCostos from "./FormaCalculoCostos";

export default function Calculos() {
  const { step } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return step > 4 ? <FormaCalculoCostos /> : <></>;
}
